import { Component, Input, OnInit, inject } from '@angular/core';
import { ReportingService } from '../../reporting.service';
import { Application, Unit } from '../../../models/admin-models';
import { SessionStorageService } from '../../../services/session-storage.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-report-request',
  templateUrl: './report-request.component.html',
  styleUrls: ['./report-request.component.scss'],
  standalone: false,
})
export class ReportRequestComponent implements OnInit {
  private rptSvc = inject(ReportingService);
  private snacky = inject(MatSnackBar);
  private ss = inject(SessionStorageService);

  @Input() baseUrl;
  @Input() dashboardSettings;

  applications: Application[] = [];
  units: Unit[] = [] as Unit[];
  selectedApp;
  reportTypes: string[];
  selectedType;
  loading = false;
  startDate;
  endDate;
  reportDetails = '';
  email;
  reportOptions = [];

  ngOnInit(): void {
    this.ss.get('globals')?.Modules.forEach(module => {
      switch (module.toLowerCase()) {
        case 'aw':
          this.applications.push({
            name: 'Annuity Wizard',
            value: module.toLowerCase(),
          });
          break;
        case 'iw':
          this.applications.push({
            name: 'Investment Wizard',
            value: module.toLowerCase(),
          });
          break;
        case 'li':
          this.applications.push({
            name: 'Life Insurance Wizard',
            value: module.toLowerCase(),
          });
          break;
        case 'pp':
          this.applications.push({
            name: 'Product Profiler',
            value: module.toLowerCase(),
          });
          break;
        case 'posttrade':
          this.applications.push({
            name: 'Post Transaction Monitor',
            value: 'pt',
          });
          break;
        case 'aml':
          this.applications.push({
            name: 'AML Monitor',
            value: module.toLowerCase(),
          });
          break;
        default:
          break;
      }
    });
  }

  formatReportOptions(reportType) {
    this.reportOptions = [];
    if (
      this.dashboardSettings[`${reportType}ReportOptions`] &&
      this.dashboardSettings[`${reportType}ReportDescriptions`]
    ) {
      this.dashboardSettings[`${reportType}ReportOptions`].map(
        (reportName, index) => {
          this.reportOptions.push({
            name: reportName,
            description:
              this.dashboardSettings[`${reportType}ReportDescriptions`][index],
          });
        }
      );
    }
  }

  submitReportRequest() {
    this.loading = true;
    const {
      user: { id, username },
      firmId,
    } = this.ss.get('globals');
    const reportData = {
      templateName: 'dashboardReportEmail',
      sendTo: this.dashboardSettings.SendToEmails,
      data: {
        module: this.selectedApp,
        startDate: this.startDate,
        endDate: this.endDate,
        reportSelected: this.selectedType,
        deliveryEmailOnceCompleted: this.email,
        submittedBy: {
          userId: id,
          userName: username,
          firmId,
        },
      },
    };

    if (this.reportDetails) {
      reportData['data']['reportDetails'] = this.reportDetails;
    }

    this.rptSvc.submitReportRequest(reportData).subscribe({
      next: () => {
        this.snacky.open('Report request submitted, thank you.', 'Close', {
          duration: 3000,
        });
        this.loading = false;
      },
      error: error => {
        if (error) {
          console.error('error: ', error);
          this.snacky.open(
            'Whoops something went wrong, please try again later!',
            'Close',
            {
              duration: 3000,
            }
          );
          this.loading = false;
        }
      },
    });
  }

  onAppChange() {
    this.reportTypes =
      this.dashboardSettings[`${this.selectedApp.toUpperCase()}ReportOptions`];

    this.formatReportOptions(this.selectedApp.toUpperCase());
  }
}
